import { useNewRelic } from '@e3dc-react/shell/Libs/observability-tool'
import React from 'react'
import { useChartDateBarContext } from '../../../chart-kit/shared/context'
import { useUserSettings } from 'src/Hooks'
import { Resolution } from '../../../chart-kit/shared/types'
import ExportWrapper from '../../../chart-kit/shared/components/export/ExportWrapper'
import useCostSavingExportData from '../../hooks/cost-saving-chart/use-cost-saving-export-data'
import { exportAsCsv } from '../../../chart-kit/shared/utils/export/export-as-csv'

interface Props {
  filename: string
  tooltip?: string
  dataQa?: string
}

/**
 * Component to export cost saving data to CSV file via button or menu.
 */
const ExportCostSavingData: React.FC<Props> = ({ filename, tooltip, dataQa }) => {
  const { pageActions } = useNewRelic()
  const { userSettings, isUserSettingsLoading } = useUserSettings()
  const { view } = useChartDateBarContext()
  const { getCostSavingExportData, isFetching } = useCostSavingExportData(view)

  const handleOnExport = async (resolution: Resolution): Promise<void> => {
    if (isUserSettingsLoading) return
    pageActions.componentClicked({
      componentName: 'chart-csv-export-button-cost-saving-data',
      userId: userSettings.userid?.toString(),
    })
    const { csvData, csvHeaders } = await getCostSavingExportData(resolution)

    exportAsCsv(filename, csvData, csvHeaders)
  }

  return <ExportWrapper onExport={handleOnExport} dataQa={dataQa} isFetching={isFetching} tooltip={tooltip} />
}

export default ExportCostSavingData
